import script from "./SimulateFassets.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulateFassets.vue?vue&type=script&setup=true&lang=js"

import "./SimulateFassets.vue?vue&type=style&index=0&id=6204a986&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6204a986"]])

export default __exports__